import React, { useEffect, useState } from "react";
import SubHeader from "../layout/subheader";
import Markdown from "react-markdown";
import remarkGfm from "remark-gfm";
import SyntaxHighlighter from "react-syntax-highlighter";
import "../shared/markdown/markdown.css";
import { rehypeGithubAlerts } from "rehype-github-alerts";
import remarkMermaid from "remark-mermaidjs";
import admonitionOptions from "../shared/markdown/admonition";
import fetchNavElements from "../shared/navElements";
import { useSelector } from "react-redux";
import { storeProps } from "../store";

const Home = (): JSX.Element => {
  const navElements = useSelector((state: storeProps) => state.nav.nav);
  const [software, setSoftware] = useState<any>([]);
  useEffect(() => {
    if (navElements) {
      const modifiedData = navElements.slice(1, navElements.length - 1);
      setSoftware(modifiedData);
    }
  }, [navElements]);

  // explain how to use this page it is a in md
  const markdown = `
# Welcome to the Minebea-Intec Software Portfolio

This web application is designed to provide a comprehensive overview of the software products offered by Minebea-Intec. 

## Navigation

On the left side of the page, you will find a list of links. Each link corresponds to a different software product offered by Minebea-Intec. 

To view the details of a software product, simply click on the corresponding link. 

## Software Details

When you select a software product, you will be presented with a detailed overview of the product.

This includes a comprehensive description of the software, a list of its key features, and other relevant information. 

## Downloading Software

In the software details section, you will find a download link. Click on this link to download the software to your device.

Please note that you may need to meet certain system requirements in order to successfully install and run the software. 

## Release Notes

Alongside the download link, you will also find the release notes for the software.

These notes provide important information about the latest updates, bug fixes, and improvements made to the software.

We recommend reading these notes before downloading and installing the software. 

## Support

If you encounter any issues while using this web application or have any questions about our software products, please do not hesitate to contact our support team.

We are committed to providing you with a seamless experience and are always here to help. 

Thank you for choosing Minebea-Intec. We hope you find our software products beneficial and our web application easy to use.

## Software Products

The following Software products are available for download:
`;

  return (
    <>
      <SubHeader header="Product portfolio" />
      <div className="row">
        <div className="col hmi-inner-content">
          <div className="row">
            <div className="col-12">
              <div className="inner wc markdown">
                <Markdown
                  remarkPlugins={[remarkGfm, remarkMermaid]}
                  rehypePlugins={[[rehypeGithubAlerts, admonitionOptions]]}
                  remarkRehypeOptions={{
                    allowDangerousHtml: true,
                  }}
                  children={markdown}
                  components={{
                    code(props) {
                      const { children, className, node, ...rest } = props;
                      const match = /language-(\w+)/.exec(className || "");
                      return match ? (
                        <SyntaxHighlighter
                          PreTag="div"
                          children={String(children).replace(/\n$/, "")}
                          language={match[1]}
                        />
                      ) : (
                        <code {...rest} className={className}>
                          {children}
                        </code>
                      );
                    },
                  }}
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <div className="inner wc markdown">
                {software.map((item: any) => {
                  return (
                    <div key={item.text}>
                      <h3>{item.text}</h3>
                      <ul>
                        {item.expandableMenuItems?.map((subitem: any) => {
                          return (
                            <li key={subitem.text}>
                              <a href={subitem.url}>{subitem.text}</a>
                            </li>
                          );
                        })}
                      </ul>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Home;
